import { Runtime, pipe, ReadonlyArray } from "fp";

import * as Data from "~/Data";
import * as Driver from "~/Driver";
import * as Log from "~/Log";
import * as OptionalNonEmptyString from "~/OptionalNonEmptyString";

export const runtime = () =>
  Runtime.strict({
    details: Runtime.array(Log.Event.Response.runtime()),
    metadata: Metadata.runtime(),
  });

export namespace Query {
  export const decode = ({ driver, dateTime }: Log.Identity) => (
    response: Runtime.ToType<typeof runtime>
  ): Log.Log => {
    return pipe({
      ...Metadata.decode(driver)(response.metadata),
      dateTime,
      suggestions: { withEvent: Data.Cache.empty() },
      events: pipe(
        response.details,
        ReadonlyArray.map((response) =>
          pipe(response, Log.Event.Response.decode(driver))
        )
      ),
    });
  };
}

namespace Metadata {
  export const runtime = () =>
    Runtime.intersection([
      Log.Signature.Response.runtime(),
      Log.Assets.Response.runtime(),
      Driver.Name.Response.runtime(),
      Driver.Name.Response.runtime(),

      Runtime.strict({
        co_driver: OptionalNonEmptyString.Response.runtime(),
        distance: Runtime.number(),
        shipping_docs: OptionalNonEmptyString.Response.runtime(),
      }),
    ]);

  export const decode = (driver: Data.Reference.Reference) => (
    response: Runtime.ToType<typeof runtime>
  ): Pick<
    Log.Log,
    "driver" | "coDriver" | "signature" | "assets" | "distance" | "documents"
  > => ({
    driver: { ...driver, name: Driver.Name.Response.decode(response) },
    coDriver: OptionalNonEmptyString.Response.decode(response.co_driver),
    signature: Log.Signature.Response.decode(response),
    assets: Log.Assets.Response.decode(response),
    distance: response.distance,
    documents: OptionalNonEmptyString.Response.decode(response.shipping_docs),
  });
}
